import { render, staticRenderFns } from "./portalPromptModal.vue?vue&type=template&id=33fb953e&scoped=true&"
import script from "./portalPromptModal.vue?vue&type=script&lang=js&"
export * from "./portalPromptModal.vue?vue&type=script&lang=js&"
import style0 from "./portalPromptModal.vue?vue&type=style&index=0&id=33fb953e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb953e",
  null
  
)

export default component.exports